module.exports = __webpack_public_path__ + "static/img/vimg3.6e7c9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vimg3.jpg
// module id = Wqqb
// module chunks = 0